var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2 60.8h-57.6c-0.57 0-1.094-0.301-1.382-0.794s-0.291-1.098-0.013-1.594l28.8-51.2c0.285-0.502 0.816-0.816 1.395-0.816s1.11 0.31 1.395 0.816l28.8 51.2c0.278 0.496 0.272 1.101-0.013 1.594s-0.813 0.794-1.382 0.794zM4.336 57.6h52.128l-26.064-46.336-26.064 46.336z",
    fill: "#E0AD03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 44.8c-0.883 0-1.6-0.717-1.6-1.6v-16c0-0.883 0.717-1.6 1.6-1.6s1.6 0.717 1.6 1.6v16c0 0.883-0.717 1.6-1.6 1.6z",
    fill: "#E0AD03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 54.4c-0.883 0-1.6-0.717-1.6-1.6v-3.2c0-0.883 0.717-1.6 1.6-1.6s1.6 0.717 1.6 1.6v3.2c0 0.883-0.717 1.6-1.6 1.6z",
    fill: "#E0AD03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportant);
export default __webpack_public_path__ + "static/media/important.f18cfd2f55be2ba859e8742b195487c5.svg";
export { ForwardRef as ReactComponent };